import styled from 'styled-components';
import { InputNumber } from 'antd';

export const InputNumberWrapper = styled(InputNumber)`
	width: 100% !important;
	height: 40px !important;
	font-size: 16px !important;
	font-weight: 400 !important;
	line-height: 40px !important;
	border-radius: 4px !important;
	border: 1px solid ${({ theme }) => theme.palette.secondary['150']} !important;

	&.ant-input-number-status-error {
		border-color: #ff4d4f !important;
	}
`;
